var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2235",
    "data-name": "Rectangle 2235",
    width: 32,
    height: 40,
    transform: "translate(-2 -2)",
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10211",
    "data-name": "Group 10211",
    transform: "translate(1.699 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10210",
    "data-name": "Group 10210",
    transform: "translate(0.3 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27575",
    "data-name": "Path 27575",
    d: "M14.3,0A14.3,14.3,0,0,0,0,14.3c0,9.654,12.6,20.555,13.136,21.019a1.8,1.8,0,0,0,2.326,0C16.086,34.854,28.6,23.953,28.6,14.3A14.3,14.3,0,0,0,14.3,0m0,31.548C10.491,27.973,3.575,20.266,3.575,14.3a10.724,10.724,0,0,1,21.448,0c0,5.967-6.916,13.694-10.724,17.249m0-24.4A7.149,7.149,0,1,0,21.448,14.3,7.152,7.152,0,0,0,14.3,7.149m0,10.724A3.575,3.575,0,1,1,17.874,14.3,3.576,3.576,0,0,1,14.3,17.874",
    transform: "translate(-0.403 -0.001)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon13);
export default __webpack_public_path__ + "static/media/social_icon13.ce1204be44e9b7b8d084b4e9fde68ce5.svg";
export { ForwardRef as ReactComponent };